import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserProfile from './UserProfile';
import UserProfileDropdown from './UserProfileDropdown';
import CollapsibleMenu from './CollapsibleMenu';

// Reusable application header used on main and merge pages
// Props:
// - credits: number
// - generated: number
// - user: { name?: string, email?: string } | null
// - onLogout: () => void
// - onRecharge: () => void
const AppHeader = ({ credits = 0, generated = 0, user, onLogout, onRecharge }) => {
  const location = useLocation();
  const onMergePage = location.pathname.startsWith('/merge');
  const navTarget = onMergePage ? '/' : '/merge';
  // Human-friendly labels
  const navLabel = onMergePage ? 'AI Model' : 'Real Human Model';
  
  // Mobile profile dropdown state
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  // Collapsible menu state
  const [showCollapsibleMenu, setShowCollapsibleMenu] = useState(false);

  return (
    <header className="app-header">
      <div className="container">
        <div className="header-content">
          {/* Mobile header - compact icon-based design */}
          <div className="mobile-header-compact">
            {/* Left: Hamburger menu button */}
            <button 
              className="mobile-menu-toggle" 
              onClick={() => setShowCollapsibleMenu(true)}
              aria-label="Open menu"
              title="Menu"
            >
              ☰
            </button>

            {/* Center: Credits remaining + Recharge icon */}
            <div className="mobile-credits-display">
              <div className="mobile-credits-wrapper">
                <span className="mobile-credits-label">Available:</span>
                <span className="mobile-credits-value">{credits}</span>
              </div>
              {onRecharge && (
                <button 
                  className="mobile-recharge-icon-btn" 
                  onClick={onRecharge} 
                  title="Recharge Credits"
                  aria-label="Recharge"
                >
                  <img src="/wallet-icon.svg" alt="Recharge" className="recharge-icon-img" />
                </button>
              )}
            </div>

            {/* Right: Profile icon (clickable) */}
            <UserProfile onClick={() => setShowProfileDropdown(true)} />
          </div>


          {/* Collapsible Menu */}
          {showCollapsibleMenu && (
            <CollapsibleMenu onClose={() => setShowCollapsibleMenu(false)} />
          )}

          {/* Profile Dropdown for Mobile */}
          {showProfileDropdown && (
            <UserProfileDropdown
              user={user}
              creditsUsed={generated}
              onLogout={onLogout}
              onClose={() => setShowProfileDropdown(false)}
            />
          )}

          {/* Desktop brand on the left - logo with hamburger menu */}
          <div className="brand-left desktop-only" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button 
              className="desktop-menu-toggle" 
              onClick={() => setShowCollapsibleMenu(true)}
              aria-label="Open menu"
              title="Menu"
            >
              ☰
            </button>
            <Link to="/" aria-label="Home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
              <img src="/logobg.png" alt="photoshoot" className="brand-logo-desktop" />
            </Link>
          </div>
          <div className="header-stats desktop-only">
            <UserProfile onClick={() => {}} />
            <div className="wallet-info">
              <div className="wallet-item">
                <span className="wallet-label">Credits:</span>
                <span className="wallet-value">{credits}</span>
              </div>
              <div className="wallet-item">
                <span className="wallet-label">Credits Used:</span>
                <span className="wallet-value">{generated}</span>
              </div>
              {onRecharge && (
                <button className="recharge-btn-header" onClick={onRecharge} title="Recharge Credits">
                  <img src="/wallet-icon.svg" alt="Wallet" className="recharge-icon-img-header" />
                  <span>Recharge</span>
                </button>
              )}
            </div>
            <button
              className="logout-btn-standard desktop-only"
              onClick={onLogout}
              aria-label="Logout"
              title="Logout"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;


